import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { visibleZonesMapSelector } from '../../features/places/placesSlice';
import { mapServiceSelector } from '../../features/map/mapSlice';

import GoogleZonePolygon from './google/GoogleZonePolygon';
import OsmZonePolygon from './osm/OsmZonePolygon';

const ZoneOverlay = ({ map }) => {
    const visibleZonesMap = useSelector(visibleZonesMapSelector);
    const mapService = useSelector(mapServiceSelector);

    const plotZones = useCallback(
        () => {
            return visibleZonesMap.map(zoneId =>
                mapService === 'google' ?
                    <GoogleZonePolygon
                        key={zoneId}
                        zoneId={zoneId}
                        map={map}
                    />
                    :
                    <OsmZonePolygon
                        key={zoneId}
                        zoneId={zoneId}
                    />
            );
        },
        [visibleZonesMap, mapService, map],
    );

    return (
        <div>{plotZones()}</div>
    );
}

export default ZoneOverlay;